import jwt from 'jsonwebtoken';

export const getName = () => {
  let name = null;
  const userFullname = localStorage.getItem('userFullName');
  const token = localStorage.getItem('token');
  /** If not token or user, just return null */
  if (!token) return name;
  const user = jwt.decode(token);
  if (!user) return name;

  /** First check if user is coming from onboarding with updated name */
  if (userFullname) {
    name = userFullname.split(' ')[0];
    name = name && name.toLowerCase() !== 'undefined' ? name : null;
  } else if (user && user.name) {
    /** Check name from token if not set from local storage */
    name = user.name.split(' ')[0];
    name = name && name.toLowerCase() !== 'undefined' ? name : null;
  }
  return name === 'null' ? 'User' : name;
};

export const getUserObject = () => {
  let user = {};
  const token = localStorage.getItem('token');
  const decoded = jwt.decode(token);
  if (decoded) user = decoded;
  return user;
};
